export const feedbackStoreKey = 'feedback';
